import React, { Fragment, lazy, Suspense } from "react";
import { useGenericStore } from "@customHooks/useGenericStore.js";
import Loading from "@genericComponents/Loading.js";
import { FILTERHOLDER } from "@genericComponents/CFW.js";
const ShowFilter = lazy(() => import("@controls/Filter/ShowFilter.js"));
export const Filter = () => {
  const param = useGenericStore(FILTERHOLDER);
  if (param) {
    return (
      <Suspense fallback={<Loading />}>
        <ShowFilter param={param} />
      </Suspense>
    );
  }
  return <Fragment />;
};
